export default {"src":"/_next/static/media/v5.cd7aa24a.svg","height":130,"width":332};